var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 189.303,
    height: 52.511,
    viewBox: "0 0 189.303 52.511",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1000",
    "data-name": "Rectangle 1000",
    width: 189.302,
    height: 52.51,
    fill: "#104ef5"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2334",
    "data-name": "Group 2334",
    transform: "translate(-176.084 -377.261)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2329",
    "data-name": "Group 2329",
    transform: "translate(176.085 377.261)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_41410",
    "data-name": "Path 41410",
    d: "M306.106,421.078l10.388-10.444s-.005-19.356-.005-30.193c0-.133-.009-.266-.019-.4l-.045-.809h-10.4v41.823H289.329V379.235h-10.4l-.028.656c0,.074-.008.142-.012.207-.008.124-.015.238-.015.351v6.2q0,17.575,0,35.151c.006,4.956,4.341,9,9.663,9.02,2.795.01,5.614.014,8.412.014,3.342,0,6.652-.005,9.852-.011a9.772,9.772,0,0,0,6.592-2.446,8.719,8.719,0,0,0,3.1-6.59l.025-.71Z",
    transform: "translate(-233.154 -378.357)",
    fill: "#104ef5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41411",
    "data-name": "Path 41411",
    d: "M237,400.157l10.388-4.862v-16.06H236.913v20.9",
    transform: "translate(-209.859 -378.357)",
    fill: "#104ef5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41412",
    "data-name": "Path 41412",
    d: "M578.17,387.675l.009,42.027H588.57l.069-52.44Z",
    transform: "translate(-399.337 -377.261)",
    fill: "#104ef5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41413",
    "data-name": "Path 41413",
    d: "M418.987,409.1c0-9.054-10.4-9.038-10.478-9.054l10.5-4.88s-.01-2.311-.01-3.467,0-2.32-.01-3.479a8.305,8.305,0,0,0-.191-1.742,9.641,9.641,0,0,0-9.666-7.335q-8.768,0-17.537,0H381.427v51.631h10.458q8.678,0,17.356-.008a10.381,10.381,0,0,0,1.979-.181A9.242,9.242,0,0,0,419,421.665q.009-4.823,0-9.646Zm-27.1-20.159h16.628v11.105H391.882Zm16.663,31.224V421H391.879V409.865h16.668c0,3.032,0,7.819,0,10.3",
    transform: "translate(-290.098 -378.308)",
    fill: "#104ef5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41414",
    "data-name": "Path 41414",
    d: "M515.059,387.159h0a9.472,9.472,0,0,0-9.482-7.986c-8-.016-28.3,0-28.3,0l10.469,10.5h16.487c-2.395,3.852-6.93,11.019-11.708,18.568-5.381,8.5-10.946,17.3-13.212,20.984-.072.12-.136.242-.215.392l-.64,1.2,4.117,0c2.213,0,4.5,0,6.752.013h.016a1.683,1.683,0,0,0,1.59-.886c6.816-11.094,14.066-22.872,22.814-37.065a8.738,8.738,0,0,0,1.308-5.719",
    transform: "translate(-343.319 -378.318)",
    fill: "#104ef5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41415",
    "data-name": "Path 41415",
    d: "M213.61,400.173v30.651H203.28V409.97H186.562v20.865H176.137l-.053-51.6h10.451v20.913h16.711Z",
    transform: "translate(-176.085 -378.357)",
    fill: "#104ef5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.f0aff163ac395cced8597a8ba7ebfe0f.svg";
export { ForwardRef as ReactComponent };